import { Head, Link } from '@inertiajs/react'
import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import type { Breadcrumb } from '@/types/shared'

export type TeamTeamChatroomsIndexProps = {
  teamChatrooms: Array<{
    id: string
    schoolName?: string | null
    schoolCoachName: string
    lastMessage?: string | null
    lastMessageAt?: string | null
  }>
  breadcrumbs: Breadcrumb[]
}

export default function TeamTeamChatroomsIndex({ teamChatrooms, breadcrumbs }: TeamTeamChatroomsIndexProps) {
  return (
    <AppShell>
      <Head title="学校からの問い合わせ" />
      <PageHeader
        title="学校からの問い合わせ"
        description="高校コーチからの問い合わせをまとめて確認・返信できます。"
        breadcrumbs={breadcrumbs}
      />

      <Card>
        {teamChatrooms.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-sm text-white/60">
            <p>まだ問い合わせはありません。</p>
          </div>
        ) : (
          <ul className="divide-y divide-white/5">
            {teamChatrooms.map((teamChatroom) => (
              <li key={teamChatroom.id}>
                <Link
                  href={`/team/team_chatrooms/${teamChatroom.id}`}
                  className="flex items-start justify-between gap-4 px-4 py-4 text-sm text-white transition hover:bg-white/5"
                >
                  <div>
                    <p className="font-semibold text-white">
                      {teamChatroom.schoolName ?? '学校未登録'}
                    </p>
                    <p className="text-xs text-white/60">{teamChatroom.schoolCoachName} コーチ</p>
                    <p className="mt-2 line-clamp-2 text-xs text-white/70">
                      {teamChatroom.lastMessage ?? 'メッセージはまだありません'}
                    </p>
                  </div>
                  {teamChatroom.lastMessageAt ? (
                    <time className="text-[11px] text-white/40">{formatDate(teamChatroom.lastMessageAt)}</time>
                  ) : null}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </AppShell>
  )
}

function formatDate(value: string) {
  return new Date(value).toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
